import React from "react";
import TrainingComponentEditor, { FormGroup } from "./TrainingComponentEditor";
import { action } from "mobx";
import { observer } from "mobx-react";

@observer
class PracticeWrite extends TrainingComponentEditor {
  initializeData() {
    return { text: "" };
  }

  @action.bound
  handleTextChange(evt) {
    this.data.text = evt.target.value;
  }

  render() {
    return (
      <FormGroup name="prompt" label="Prompt">
        {(formControl) => (
          <textarea
            {...formControl}
            value={this.data.text}
            onChange={this.handleTextChange}
          />
        )}
      </FormGroup>
    );
  }
}

export default PracticeWrite;
